/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, September 17th 2022, 1:06:51 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Team } from "lib/schemas";
import { schemaBuilder, fileBaseSchema, Many2ManyUUIDPKBaseSchema } from "lib/validation";
import { ProcessDefinition } from "lib/schemas/service-builder/process-definition/ProcessDefinition";
import { PrimaryKeyValue } from "lib/types";

export interface InstallPreBuiltService {
  organization_id: string;
  service_code?: string;
  site_id: number;
  team_ids?: Team["id"][];
  installation_file?: any;
}

export interface InstallPreBuiltServiceResponse {
  installed_process_definition_id: PrimaryKeyValue<ProcessDefinition>;
  [key: string]: string;
}

export const InstallPreBuiltServiceValidationSchema: schemaBuilder.SchemaOf<InstallPreBuiltService> = schemaBuilder
  .object()
  .shape({
    organization_id: schemaBuilder.string().uuid().required("Organization for the installed service is required"),
    service_code: schemaBuilder
      .string()
      .required("Please provide a code for the service that will be installed from this template."),
    site_id: schemaBuilder
      .number()
      .required("You must select a site where this service will be installed")
      .typeError("You must select a site where this service will be installed"),

    team_ids: Many2ManyUUIDPKBaseSchema().nullable().optional(),
    installation_file: fileBaseSchema({ sizeLimit: 50097152 }).nullable(),
  });
